<mat-card>
  <mat-card-header>
   <mat-card-title>
  <div class="header-row">
    <span>Upcoming Activities</span>
    <button type="button" class="view-all-link" (click)="openCalendar()">View all</button>
  </div>
</mat-card-title>
  </mat-card-header>

 <mat-card-content>
  @if (loading) {
    <div class="loading-row">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  } @else if (error) {
    <div class="empty-state">
      <mat-icon>error_outline</mat-icon>
      <p>Couldn't load activities.</p>
      <button type="button" mat-button (click)="load()">Retry</button>
    </div>
  } @else if (!groups.length) {
    <div class="empty-state">
      <mat-icon>event_busy</mat-icon>
      <p>No record found.</p>
    </div>
  } @else {
    @for (group of groups; track group.label) {
      <div class="day-group">
        <p class="day-label">{{ group.label }}</p>

        @for (activity of group.items; track activity.id) {
          <div class="activity-row" (click)="openDay(group)">
            <div class="icon-badge" [ngClass]="activity.type">
              <mat-icon>{{ iconFor(activity.type) }}</mat-icon>
            </div>
            <div class="info">
              <div class="title">{{ activity.title }}</div>
              <div class="time">{{ activity.start | date:'shortTime' }}</div>
            </div>
            <span class="status-pill" [ngClass]="activity.type">{{ activity.type }}</span>
          </div>
        }
      </div>
    }
  }
</mat-card-content>
</mat-card>
